import { createSelector } from 'reselect';

export const getCategoriesIsLoading = state => state.categories.isLoading;

const getIds = state => state.categories.data;
const getResult = state => state.entities.categories;
export const getAllCategories = createSelector(
  getIds,
  getResult,
  (ids, result) => {
    return ids
      .map(id => {
        return result[id];
      })
      .sort((a, b) => {
        let fieldA = a.id;
        let fieldB = b.id;

        if (fieldA < fieldB) {
          return -1;
        }
        if (fieldA > fieldB) {
          return 1;
        }

        return 0;
      });
  }
);



// WEBPACK FOOTER //
// ./src/redux/selectors/categories.js